import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import UpcomingEvents from './components/UpcomingEvents';
export default function addHomeEvents() {
  // Lowest priority in the sidebar (see champis-species' own
  // addSpeciesSearch.js at 200 and addHomeDescriptions.js at -10) - sits at
  // the very bottom, matching champis.net/home's own layout where
  // "Prochains événements" is the last thing in the right column, below
  // "Descriptions".
  extend(IndexSidebar.prototype, 'items', function (items) {
    // Homepage-only, same reasoning (and same shared-IndexSidebar gotcha)
    // as champis-species' addHomeDescriptions.js.
    if (m.route.param('tags')) return;
    items.add('champis-upcoming-events', m(UpcomingEvents, null), -20);
  });
}